module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main situation"
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "leftContent"
  }, [_c('el-collapse', {
    model: {
      value: (_vm.activeNamesFirst),
      callback: function($$v) {
        _vm.activeNamesFirst = $$v
      },
      expression: "activeNamesFirst"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "单位信息",
      "name": "1"
    }
  }, [_c('el-form', {
    ref: "unitData",
    attrs: {
      "model": _vm.unitData,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "tableContent"
  }, [_c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("所属区域")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.unitData.provinceId),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "provinceId", $$v)
      },
      expression: "unitData.provinceId"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.areaName,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.onSelectCity
    },
    model: {
      value: (_vm.unitData.cityId),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "cityId", $$v)
      },
      expression: "unitData.cityId"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.areaName,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.onSelectArea
    },
    model: {
      value: (_vm.unitData.areaId),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "areaId", $$v)
      },
      expression: "unitData.areaId"
    }
  }, _vm._l((_vm.areaList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.areaName,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("单位全称")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "fullName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入单位全称"
    },
    model: {
      value: (_vm.unitData.fullName),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "fullName", $$v)
      },
      expression: "unitData.fullName"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("单位简称")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "simpName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入单位简称"
    },
    model: {
      value: (_vm.unitData.simpName),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "simpName", $$v)
      },
      expression: "unitData.simpName"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_c('i', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("组织机构编码")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "organizationCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入组织机构编码"
    },
    model: {
      value: (_vm.unitData.organizationCode),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "organizationCode", $$v)
      },
      expression: "unitData.organizationCode"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("报警编号前缀")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unitData.accidentNoPrefix),
      expression: "unitData.accidentNoPrefix"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入报警编号前缀"
    },
    domProps: {
      "value": (_vm.unitData.accidentNoPrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unitData, "accidentNoPrefix", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("排序号")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unitData.indexNo),
      expression: "unitData.indexNo"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入排序号"
    },
    domProps: {
      "value": (_vm.unitData.indexNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.unitData, "indexNo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("音视频能力")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.unitData.trtcStatus),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "trtcStatus", $$v)
      },
      expression: "unitData.trtcStatus"
    }
  }, _vm._l((_vm.optionList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("预约状态")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.unitData.bookingStatus),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "bookingStatus", $$v)
      },
      expression: "unitData.bookingStatus"
    }
  }, _vm._l((_vm.optionList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("支付二维码状态")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.unitData.payqrStatus),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "payqrStatus", $$v)
      },
      expression: "unitData.payqrStatus"
    }
  }, _vm._l((_vm.optionList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("pc创建预约单")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.unitData.pcCreateStatus),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "pcCreateStatus", $$v)
      },
      expression: "unitData.pcCreateStatus"
    }
  }, _vm._l((_vm.optionList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("发送短信")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.unitData.sendSmsStatus),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "sendSmsStatus", $$v)
      },
      expression: "unitData.sendSmsStatus"
    }
  }, _vm._l((_vm.optionList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("全时段")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.unitData.allTimeModifyStatus),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "allTimeModifyStatus", $$v)
      },
      expression: "unitData.allTimeModifyStatus"
    }
  }, _vm._l((_vm.optionList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-49"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("半身照必填")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.unitData.halfBodyPhotoStatus),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "halfBodyPhotoStatus", $$v)
      },
      expression: "unitData.halfBodyPhotoStatus"
    }
  }, _vm._l((_vm.optionList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-item h-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', [_vm._v("备注")])]), _vm._v(" "), _c('div', {
    staticClass: "right h32"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入备注",
      "maxlength": "120",
      "resize": "none",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.unitData.desc),
      callback: function($$v) {
        _vm.$set(_vm.unitData, "desc", $$v)
      },
      expression: "unitData.desc"
    }
  })], 1)])])])])])], 1)], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNamesThird),
      callback: function($$v) {
        _vm.activeNamesThird = $$v
      },
      expression: "activeNamesThird"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "图章上传",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "wholeAcccindentClass"
  }, [_c('div', {
    staticClass: "accidentImages"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "img-box"
  }, [(_vm.unitData.stampUrl) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [(/(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(_vm.unitData.stampUrl)) ? _c('div', {
    staticClass: "video-wrap"
  }, [_c('i')]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getImageUrl(_vm.unitData.stampUrl, ''),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.unitData.stampUrl)
      }
    }
  })]) : _c('div', {
    staticClass: "img-mask-no"
  }, [(!_vm.unitData.stampUrl) ? _c('i', {
    staticClass: "el-icon-upload"
  }) : _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.unitData.stampUrl)
      }
    }
  }), _vm._v(" "), (!_vm.unitData.stampUrl) ? _c('div', [_vm._v("上传图片")]) : _vm._e()])]), _vm._v(" "), _c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.action,
      "auto-upload": false,
      "headers": _vm.headers,
      "show-file-list": false,
      "on-change": _vm.handleChange,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.uploadSuccess
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1)])])])], 1), _vm._v(" "), _c('el-collapse', {
    model: {
      value: (_vm.activeNamesFourth),
      callback: function($$v) {
        _vm.activeNamesFourth = $$v
      },
      expression: "activeNamesFourth"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "水印上传",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "wholeAcccindentClass"
  }, [_c('div', {
    staticClass: "accidentImages"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "img-box"
  }, [(_vm.unitData.watermarkUrl) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [(/(swf|avi|flv|mpg|rm|mov|wav|asf|3gp|mkv|rmvb|mp4)$/.test(_vm.unitData.watermarkUrl)) ? _c('div', {
    staticClass: "video-wrap"
  }, [_c('i')]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.getImageUrl(_vm.unitData.watermarkUrl, 1),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.unitData.watermarkUrl)
      }
    }
  })]) : _c('div', {
    staticClass: "img-mask-no"
  }, [(!_vm.unitData.watermarkUrl) ? _c('i', {
    staticClass: "el-icon-upload"
  }) : _c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        return _vm.previewImg(_vm.unitData.watermarkUrl)
      }
    }
  }), _vm._v(" "), (!_vm.unitData.watermarkUrl) ? _c('div', [_vm._v("上传图片")]) : _vm._e()])]), _vm._v(" "), _c('el-upload', {
    ref: "uploadMark",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.actionWatermarkUrl,
      "auto-upload": false,
      "headers": _vm.headers,
      "show-file-list": false,
      "on-change": _vm.handleChangeMark,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": _vm.uploadSuccessMark
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1)], 1)])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bottomBtns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveUnitData('unitData')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.closeMask
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27cde5bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/unitManagement/detail.vue
// module id = Zyi7
// module chunks = 6